import UtilsSchema from "@repoflow/schema/utils";
import TypesSchema from "@common/schema/types";

import {
  siteKey,
  orgId,
  siteId,
  collectionId,
  title,
  description,
  image,
  postIds,
  createdAt,
  updatedAt,
} from "./fields";

export default [
  ...UtilsSchema,
  ...TypesSchema,
  {
    id: "/Public/BlogCollection",
    type: "object",
    properties: {
      siteKey,
      orgId,
      siteId,
      collectionId,
      title,
      description,
      image,
      postIds,
      createdAt,
      updatedAt,
    },
  },
  {
    id: "/Public/BlogCollection/Create",
    type: "object",
    properties: {
      collectionId,
      title,
    },
    required: ["collectionId", "title"],
  },
  {
    id: "/Public/BlogCollection/Update",
    type: "object",
    properties: {
      title,
      description,
      image,
      postIds,
    },
    required: ["title"],
  },
];
